import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

export const fetchPackages = createAsyncThunk(
  "packages/fetchPackages",
  async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && filters[key] !== "") {
        params.append(key, filters[key]);
      }
    });
    const res = await axios.get(`${BASE_URL}/packages?${params.toString()}`);
    return res.data;
  }
);

export const fetchPackageById = createAsyncThunk(
  "packages/fetchPackageById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/packages/${id}`);
    return res.data;
  }
);

export const createPackage = createAsyncThunk(
  "packages/createPackage",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/packages`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Paket oluşturulamadı");
    }
  }
);

export const updatePackage = createAsyncThunk(
  "packages/updatePackage",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${BASE_URL}/packages/${id}`, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Paket güncellenemedi");
    }
  }
);

export const deletePackage = createAsyncThunk(
  "packages/deletePackage",
  async (id) => {
    await axios.delete(`${BASE_URL}/packages/${id}`);
    return id;
  }
);

const packageSlice = createSlice({
  name: "packages",
  initialState: {
    items: [],
    selectedPackage: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackages.pending, (state) => { state.loading = true; })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchPackageById.fulfilled, (state, action) => {
        state.selectedPackage = action.payload;
      })

      .addCase(createPackage.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.items.unshift(action.payload);
      })
      .addCase(createPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatePackage.fulfilled, (state, action) => {
        state.items = state.items.map((p) =>
          p._id === action.payload._id ? action.payload : p
        );
      })
      .addCase(updatePackage.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deletePackage.fulfilled, (state, action) => {
        state.items = state.items.filter((p) => p._id !== action.payload);
      });
  },
});

export const { clearError } = packageSlice.actions;
export default packageSlice.reducer;
